// src/utils/dates.ts
export function formatDateTime(v?: string | number | Date, locale?: string) {
  if (!v) return '—';
  const d = v instanceof Date ? v : new Date(v);
  return d.toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Локальный YYYY-MM-DD без UTC-сдвига.
 * Раньше использовалось d.toISOString().slice(0,10) (UTC) → сдвигало границы суток.
 * Теперь используем локальное время, чтобы группировка по дням совпадала с UI и KPI.
 */
export function toISODateKey(v: string | number | Date) {
  const d = v instanceof Date ? v : new Date(v);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`; // YYYY-MM-DD в ЛОКАЛИ
}
